export default "__VITE_ASSET__KiTqDkqP__"